import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputBase,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../../redux/investigation/actions";
import "./filePreview.scss";
import TablePagination from "@mui/material/TablePagination";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DateRangePicker from "../../../components/DateRangePicker";
import moment from "moment";
import ClearIcon from "@mui/icons-material/Clear";
import { action } from "../../../constants/action";
import SearchIcon from "@mui/icons-material/Search";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import CAMHeader from "../../../components/Header/CAMHeader";
import FilePreviewTable from "../../../components/Table/FilePreviewTable";
import CAMSubHeader from "../../../components/Header/CAMSubHeader";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import Label from "../../../components/Label/Label";

const FilesPreview = () => {
  const listData = useSelector(
    (state) => state?.investigation?.filesForPreviewData?.data
  );
  const location = useLocation();
  const Dispatch = useDispatch();

  const locationStateProjectName = location.state?.projectName;

  const [pageCount, setPageCount] = useState(listData?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [outputData, setOutputData] = useState([]);
  const [page, setPage] = useState(0);
  const apiStatus = useSelector(
    (state) => state?.investigation?.filesForPreviewData
  );
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [fileType, setFileType] = useState("");
  const [sDate, setSDate] = useState("");
  const [eDate, setEDate] = useState("");
  const [type, setType] = useState("project");
  const [value, setValue] = useState("");
  const [clearDates, setClearDates] = useState(false);

  useEffect(() => {
    Dispatch(acts.ClearGetFilesForPreviewApiStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      locationStateProjectName === undefined ||
      locationStateProjectName === ""
    ) {
      const data = {
        page: page + 1,
        page_size: rowsPerPage,
        fileType,
        formattedStartDate: sDate,
        formattedEndDate: eDate,
        type,
        value,
      };
      Dispatch(acts.getFilesForPreview(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Dispatch, rowsPerPage]);

  useEffect(() => {
    if (
      locationStateProjectName === undefined ||
      locationStateProjectName === ""
    ) {
      const data = {
        page: page + 1,
        page_size: rowsPerPage,
        fileType,
        formattedStartDate: sDate,
        formattedEndDate: eDate,
        type,
        value,
      };
      Dispatch(acts.getFilesForPreview(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (locationStateProjectName) {
      setValue(locationStateProjectName);

      const data = {
        page: page + 1,
        page_size: rowsPerPage,
        fileType,
        formattedStartDate: sDate,
        formattedEndDate: eDate,
        type,
        value: locationStateProjectName,
      };
      Dispatch(acts.getFilesForPreview(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationStateProjectName]);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setMessage(apiStatus?.message);
        setErr(true);
      }
    }
  }, [apiStatus]);

  useEffect(() => {
    setOutputData(listData?.data);
    setPageCount(listData?.total_count);
  }, [listData]);

  const handleChange = (event) => {
    setType(event.target.value);
    setValue("");
  };

  const handlePageChange = (event, pageNo) => {
    setPage(pageNo);
    Dispatch(
      acts.getFilesForPreview({
        page: pageNo + 1,
        page_size: rowsPerPage,
        fileType,
        formattedStartDate: sDate,
        formattedEndDate: eDate,
        type,
        value,
      })
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    setPageCount(listData?.total_count);
  };

  const filterByDate = (startDate, endDate) => {
    const formattedStartDate = startDate
      ? `${moment(startDate).format("YYYY-MM-DD")}T00:00:00.000Z`
      : "";
    const formattedEndDate = endDate
      ? `${moment(endDate).format("YYYY-MM-DD")}T23:59:00.000Z`
      : "";
    setSDate(formattedStartDate);
    setEDate(formattedEndDate);

    const data = {
      page: page + 1,
      page_size: rowsPerPage,
      fileType,
      formattedStartDate: formattedStartDate,
      formattedEndDate: formattedEndDate,
      type,
      value,
    };
    Dispatch(acts.getFilesForPreview(data));
  };
  const clear = () => {};
  const handleFileType = (event) => {
    setFileType(event.target.value);
  };

  const onChangeValue = (value) => {
    setValue(value);
  };

  const clearFileType = () => {
    setFileType("");
  };

  const clearValue = () => {
    setValue("");
  };

  const clearAll = () => {
    setType("project");
    setValue("");
    setFileType("");

    setClearDates(true);
    setTimeout(() => setClearDates(false), 100);

    const data = {
      page: page + 1,
      page_size: 100,
      fileType: "",
      formattedStartDate: "",
      formattedEndDate: "",
      type: "project",
      value: "",
    };
    Dispatch(acts.getFilesForPreview(data));
  };

  return (
    <>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <CAMSubHeader text={action.DATAPREVIEW} />
        <Grid className="files-preview-container">
          <Grid container className="files-wrap-container">
            <Grid item md={3}>
              <div className="files-view-search-container">
                <div>
                  <FormControl size="small">
                    <Select
                      className="input-select"
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={type}
                      onChange={handleChange}
                      autoWidth
                    >
                      <MenuItem value="project" selected={true}>
                        {action.TEMPLATE}
                      </MenuItem>
                      <MenuItem value="batch">{action.BATCH}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="files-search">
                  <div className="files-search-wrapper">
                    <SearchIcon />
                  </div>
                  <FormControl size="small">
                    <InputBase
                      id="searchInput"
                      className="files-input-style"
                      placeholder={action.SEARCH}
                      inputProps={{ "aria-label": "search" }}
                      onChange={(event) => onChangeValue(event.target.value)}
                      value={value}
                    />
                    {value && (
                      <IconButton
                        onClick={() => clearValue()}
                        size="small"
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: 1,
                          transform: "translateY(-50%)",
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </FormControl>
                </div>
              </div>
            </Grid>
            <Grid item md={2}>
              <FormControl fullWidth>
                <InputLabel
                  className="multiplecontrolsLabel"
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name-label"
                >
                  File Type
                </InputLabel>
                <Select
                  className="b-0"
                  size="small"
                  label="File Type"
                  value={fileType}
                  onChange={handleFileType}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="xlsx">xlsx</MenuItem>
                  <MenuItem value="pdf">pdf</MenuItem>
                  <MenuItem value="csv">csv</MenuItem>
                  <MenuItem value="json">json</MenuItem>
                </Select>
                {fileType && (
                  <IconButton
                    onClick={() => clearFileType()}
                    size="small"
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: 25,
                      transform: "translateY(-50%)",
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                )}
              </FormControl>
            </Grid>

            <Grid item md={4} className="z-999 date-picker">
              <DateRangePicker filterByDate={filterByDate} clear={clearDates} />
            </Grid>

            <Grid item>
              <Button className="btn-search" onClick={() => clearAll()}>
                Clear
              </Button>
            </Grid>
          </Grid>
          <Box className="files-list dashboard-wrap">
            {apiStatus?.loader ? (
              <DashboardTableSkaleton />
            ) : outputData?.length ? (
              <FilePreviewTable data={outputData} />
            ) : (
              !apiStatus?.loader && (
                <div className="no-data">
                  <Label
                    text="No Data Found"
                    fontSize="16"
                    fontWeight="600"
                    padding="20px"
                  />
                </div>
              )
            )}
          </Box>
          <Grid className="pagination-wrap">
            <TablePagination
              rowsPerPageOptions={[100, 200, 300, 500]}
              component="div"
              count={pageCount}
              page={parseInt(page)}
              onPageChange={handlePageChange}
              rowsPerPage={parseInt(rowsPerPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </Grid>
        {err && (
          <CustomizedSnackbars
            severity="error"
            state={err}
            text={message}
            handleClose={() => setErr(false)}
          />
        )}
      </InvestigatorContainer>
    </>
  );
};

export default FilesPreview;
